import { LoginErrorCodes } from 'pkg/actions/sso';

import type { QueryObject } from 'pkg/hooks/query_state';
import * as logger from 'pkg/logger';

export interface WorkOSError {
	error: string;
	description: string;
	hasError: boolean;
}

/**
 * Returns the user-facing message for a failed SSO login, tailored to the
 * specific error code returned by the backend when one is known.
 */
export function getSSOAuthErrorMessage(
	t: (key: string) => string,
	errorCode?: LoginErrorCodes
): string {
	if (errorCode === LoginErrorCodes.AlreadyConnectedWithDifferentExternalId) {
		return t(
			'Your account is already linked to a different identity provider account, please contact your IT admin to resolve the conflict'
		);
	}

	return t(
		'There was a problem when trying to authenticate you towards the identity provider, please try again or contact your IT admin to resolve the issue'
	);
}

/**
 * Takes the query and structures potential errors workOS provides into an object
 * @param query
 * @returns
 */
export default function getWorkOSErrors(query: QueryObject): WorkOSError {
	const error = query?.error as string;
	const errorDescription = query?.error_description as string;
	const hasWorkOSErrors = error || errorDescription;

	if (hasWorkOSErrors) {
		logger.error(new Error(error), {
			errorDescription,
		});
	}

	return {
		error,
		description: errorDescription,
		hasError: !!hasWorkOSErrors,
	};
}
